import { apiSlice } from "./apiSlice";

// const apiSlice = createApi({
//     reducerPath: "projectapi",
//     baseQuery: fetchBaseQuery({
//         baseUrl: API_END_POINT,
//         prepareHeaders: (headers, { getState }) => {

//             const token = getState()?.auth?.token;
//             // if (token) {
//             headers.set("Authorization", `Bearer ${localStorage.getItem('token')}`);
//             //headers.set("content-type", "application/json" );
//             // }
//             return headers;
//         },
//     }),
//     endpoints: (builder) => ({
//     }),
// });

const projectApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({

        // Add New Project
        addProject: builder.mutation({
            query: (project) => ({
                url: `Project`,
                method: 'POST',
                body: project,
            }),
            providesTags: ["Add-New-Project"],
        }),

        // Get All Projects
        getAllProjects: builder.query({
            query: (type) => ({
                url: `Project?projectType=${encodeURIComponent(type)}`,
                method: 'GET',
            }),
            keepUnusedDataFor: 0,
            refetchOnMountOrArgChange: true,
            providesTags: ["Project"],
        }),

        // Update Project
        updateProject: builder.mutation({
            query: ({ projectId, project }) => {
                const formData = new FormData();
                formData.append("ProjectId", projectId);
                for (let [key, value] of project.entries()) {
                    formData.append(key, value);
                }
                return {
                    url: `Project`,
                    method: 'PUT',
                    body: formData,
                };
            },
            invalidatesTags: ["Project"],
        }),


        // Delete Project
        deleteProject: builder.mutation({
            query: (id) => ({
                url: `Project/${id}`,
                method: 'DELETE',
            }),
            invalidatesTags: ["Project"],
        }),
        // Get All Projects
        getProjectDetail: builder.query({
            query: (id) => ({
                url: `project/${id}`,
                method: 'GET',
            }),
        }),
    }),
});

// export default projectApiSlice;

export const {
    useGetProjectDetailQuery,
    useAddProjectMutation,
    useGetAllProjectsQuery,
    useUpdateProjectMutation,
    useDeleteProjectMutation,
} = projectApiSlice;